<template>
  <div class="nav-settings-mobile">
    <v-card-actions @click="state.showSettings = !state.showSettings">
      <span>
        <SettingIconSVG class="icon"/>
        {{ $translate('setting.plural') }}
        <ChevronUpSVG v-if="state.showSettings" class="custom-icon"/>
        <ChevronDownSVG v-if="!state.showSettings" class="custom-icon"/>
      </span>
    </v-card-actions>
    <v-expand-transition>
      <div v-show="state.showSettings" >
        <a @click="goToState('SettingsContact')" :class="{ active: 'SettingsContact' === route }" data-testid="nav-settings-mobile">{{ $translate('setting.menu.contact') }}</a>
        <a @click="goToState('SettingsSavedPaymentMethods')" :class="{ active: 'SettingsSavedPaymentMethods' === route }" data-testid="nav-settings-saved-payment-methods">{{ $translate('setting.menu.savedPaymentMethods') }}</a>
        <a @click="goToState('SettingsAccountManagement')" :class="{ active: 'SettingsAccountManagement' === route }" data-testid="nav-settings-account-management">{{ $translate('setting.menu.accountManagement') }}</a>
      </div>
    </v-expand-transition>
  </div>
</template>
<script>
import SettingIconSVG from './../components/icons/SettingIconSVG.vue';
import ChevronUpSVG from './../components/icons/ChevronUpSVG.vue';
import ChevronDownSVG from './../components/icons/ChevronDownSVG.vue';

export default {
  name: 'SettingsDropDown',
  components: {
    SettingIconSVG,
    ChevronDownSVG,
    ChevronUpSVG
  },
  data: () => ({
    state: {
      showSettings: 0
    }
  }),
  computed: {
    route() {
      return this.$route.name;
    }
  },
  methods: {
    closeNav() {
      this.$store.dispatch('closeNav');
    },
    goToState(state) {
      this.closeNav();
      this.$router.push({name: state});
    },
  }
}
</script>
<style lang="scss">
.custom-icon {
  margin-left: 8px;
  display: inline-block;
  vertical-align: middle;
}
.nav-settings-mobile a {
  font-weight: 400 !important;
  padding-left: 32px !important;
}
</style>